import { action } from 'typesafe-actions';

import { DatasetList } from 'client/ducks/datasets-page/service';
import { OutreachRequestParams } from '@interfaces/outreach-request-params';
import { YearsFilter } from '@interfaces/years-filter';

import * as types from './types';

export const fetchDatasets = (params: OutreachRequestParams = {}) => action(types.FETCH_DATASETS_PAGE, params);
export const fetchDatasetsSuccess = (data: DatasetList, params: OutreachRequestParams) =>
    action(types.FETCH_DATASETS_PAGE_SUCCESS, { data, params });
export const fetchDatasetsError = (error: DatasetList) => action(types.FETCH_DATASETS_PAGE_ERROR, error);

export const fetchDatasetsFilters = () => action(types.FETCH_DATASETS_FILTERS);
export const fetchDatasetsFiltersSuccess = (data: YearsFilter) =>
    action(types.FETCH_DATASETS_FILTERS_SUCCESS, data);
export const fetchDatasetsFiltersError = (error: Error) =>
    action(types.FETCH_DATASETS_FILTERS_ERROR, error);
